import {
  FAQS,
  FOOTER_LINKS,
  SWAF_INFO_TEXT,
  REGISTRATION_CARDS,
  TERMS_AND_CONDITION,
  PASS_PURCHASE_SUCCESS_MESSAGE,
} from "./helper";
import { routes } from "src/shared/routes";
import { constants } from "src/shared/constants";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";

const DesktopBanner =
  "https://ss-leagues.s3.amazonaws.com/NCAA/Florida/FB26_STADUIM_PASS.jpg";
const OrderSummaryBackgroundImage =
  "https://ss-leagues.s3.amazonaws.com/NCAA/Florida/Arena Pass - StockImage.jpg";

const LogoImage =
  "https://ss-leagues.s3.amazonaws.com/NCAA/u-florida-gators.png";

export const gators_pass: TTeamConfig = {
  TEAM_SCHEMA: "gators_pass",
  TEAM_FULL_NAME: "University of Florida",
  BROWSER_TITLE: "Gators Stadium & Arena Pass",
  CLIENT_ID: "0cc9a385a0f8.seasonshare.gators-gators.us",
  VENDOR: constants.vendorUUIDs.ticketmaster,

  TEAM_GLOBAL_SETTINGS: {
    COLORS_PRIMARY: "#0021A5",
    COLORS_SECONDARY: "#FA4616",
    LOGOUT_ON_INVALID_SESSION: false,
    DEFAULT_APP_ROUTE: routes.landing,
    ACCOUNT_MANAGER_URL: "https://am.ticketmaster.com/gators/",
    DISABLE_PASS_ON_ACCOUNT_RESTRICTION: true, // check later
    NAV_MENU: {
      HIDE_EARN_REWARDS: true,
      HIDE_MANAGE_SUBSCRIPTION: true,
    },

    FOOTER: {
      LINKS: FOOTER_LINKS,
    },
  },

  LANDING_PAGE_SETTINGS: {
    PASS_BANNER: {
      PASS_DISPLAY_MODE: "separate",
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
    },

    PASS: {
      HIDE_DECIMAL_POINTS_AFTER_PRICE: true,
      SUBSCRIBE_BUTTON_TEXT: "Purchase Now",
    },

    SHOW_ALL_EVENTS_UNDER_PASS: true,

    REGISTRATION_CARD_SETTINGS: {
      REGISTRATION_CARDS,
      HIDE_SECTION_TITLE: true,
    },

    // check later
    STATIC_BANNER: {
      IS_ENABLED: true,
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
    },
    // check later
    HIDE_PASSES: true,
  },

  HOME_PAGE_SETTINGS: {
    EVENT_CARD: {
      SHOW_SINGLE_GAMES_IN_COLLAPSE: true,
      ATTEND_BUTTON_COLOR: "#FA4616",
    },
  },

  GROUP_INVITE_PAGE_SETTINGS: {
    PASS_BANNER: {
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      PASS_DISPLAY_MODE: "separate",
    },
  },

  MY_GROUP_PAGE_SETTINGS: {
    PAGE_INFO_TEXT: <SWAF_INFO_TEXT />,
  },

  CHECKOUT_PAGE_SETTINGS: {
    CHECKOUT_FORM: {
      SAVE_CARD_SWITCH_ENABLED: false,
    },
  },

  MANAGE_SUBSCRIPTION_PAGE_SETTINGS: {
    ZERO_STATE: {
      OPT_OUT_EARLIEST_DATE: new Date("10/01/2024"),
    },
  },

  IMAGES: {
    LOGO_URL: LogoImage,
    LANDING_PAGE_STATIC_BANNER_URL: DesktopBanner,
    ORDER_SUMMERY_BACKGROUND_URL: OrderSummaryBackgroundImage,
    GROUP_INVITE_PAGE_STATIC_BANNER_URL: OrderSummaryBackgroundImage,
  },

  LANGUAGES: {
    FAQS,
    TERMS_AND_CONDITION,
    PASS_PURCHASE_SUCCESS_MESSAGE,
  },
};
